/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tooltip/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Tooltip({
  children,
  viewPath = "/DesignSystem/Tooltip",
  left = "auto",
  top = "auto",
  right = "auto",
  bottom = "auto",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  paddingTop = 8,
  paddingRight = 12,
  paddingBottom = 8,
  paddingLeft = 12,
  maxWidth = 150,
  height = 23,
  backgroundColor = "rgba(0,0,0,0.05)",
  size,
  color,
  textOverflow = "ellipsis",
  whiteSpace = "nowrap",
  overflowX = "hidden",
  text
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Tooltip.Horizontal"
  data-view-path={viewPath}
 style={{'--l-1-BS6lF': typeof left === 'number' ? `${left}px` : left,'--t-2-BS6lF': typeof top === 'number' ? `${top}px` : top,'--r-3-BS6lF': typeof right === 'number' ? `${right}px` : right,'--b-4-BS6lF': typeof bottom === 'number' ? `${bottom}px` : bottom}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Tooltip.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bblr-5-BS6lF': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-6-BS6lF': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-7-BS6lF': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-8-BS6lF': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mw-13-BS6lF': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--h-14-BS6lF': typeof height === 'number' ? `${height}px` : height,'--bc-15-BS6lF': backgroundColor,'--pt-9-BS6lF': size === "small" ? "6px" : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pr-10-BS6lF': size === "small" ? "10px" : typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-11-BS6lF': size === "small" ? "6px" : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-12-BS6lF': size === "small" ? "10px" : typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--o-16-BS6lF': isBefore ? 0 : 1,'--ty-17-BS6lF': isBefore ? "-8px" : "0px"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={color || dtColorsWhite}
 textOverflow={textOverflow}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 text={text}
/>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</div>
</React.Fragment>)
}